import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "392",
  height: "124",
  viewBox: "0 0 392 124",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 77.2285V0H392V75.9688C346.241 105.207 275.01 124 195 124C116.147 124 45.8203 105.746 0 77.2285Z",
      stroke: "none"
    }, null, -1)
  ])))
}
export default { render: render }